import {Component} from "react";
import myEmitter from "./my-events";
import {Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import React from "react";
import './Science.css';
import {requestPost} from "../utils/Util";
const RadioGroup = Radio.Group;
let _window = window;
class Science extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }

        this.answer = {
            index: '',
            value:''
        };

        const {answer,currentEvaluation} = props;
        const {answers} = answer;
        if(answers[currentEvaluation.page]){
            this.state.value = answers[currentEvaluation.page].value;
        }
    }


    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    async _setAnswer(page,A){
        const {match,answercurrentEvaluation,answer} = this.props;
        var params = {
            url: window.location.href.split('question/')[1].replace(/\//g,'_'),
            info: JSON.stringify({...answer.answers,[page]:A})
        }

        const answerSet = await requestPost(`/questionnaires/test_questions_save/`,'POST', params);
        console.log(params,answerSet);
    }

    _doSetAnswer(action) {
        const {actions,currentEvaluation} = this.props;
        this.answer.index = currentEvaluation.page;
        this.answer.value = this.state.value;
        console.log(action,actions)
        this._setAnswer(currentEvaluation.page,{index:this.answer.index,value:this.answer.value});
        actions.setAnswer(currentEvaluation.page, this.answer, this.answer);
    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    keyLight(id, key, bgColor){
        var oDiv = document.getElementsByClassName(id)[0],
            sText = oDiv.innerHTML,
            bgColor = bgColor || "orange",
            sKey = "<tspan fill='"+bgColor+"';'>"+key+"</tspan>",
            num = -1,
            rStr = new RegExp(key, "g"),
            rHtml = new RegExp("\<.*?\>","ig"), //匹配html元素
            aHtml = sText.match(rHtml); //存放html元素的数组
        sText = sText.replace(rHtml, '{~}');  //替换html标签
        sText = sText.replace(rStr,sKey); //替换key
        sText = sText.replace(/{~}/g,function(){  //恢复html标签
            num++;
            return aHtml[num];
        });

        oDiv.innerHTML = sText;
    }

    componentWillMount = () => {
        let js_mathjax   = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_SVG';
        this.loadJS(js_mathjax).then(function(msg){});
    };

    componentDidMount() {
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
        myEmitter.on('prevQuestion', this._handlerNextQuestion);

        this.mathConfig();
        this.showMathjax.bind(this);

        const {MathJax} = _window;
        MathJax.Hub.Queue(["Typeset",MathJax.Hub,"root"]);
    }

    showMathjax = () => {
        const {MathJax} = _window;
        if(MathJax){
            MathJax.Hub.Queue(["Typeset",MathJax.Hub,"root"]);
        }else{
            setTimeout(this.runningMath.bind(this), 1000);
        }
    };
    runningMath = () => this.showMathjax()


    mathConfig = () => {
        console.log("----------1");
        const {MathJax} = _window;
        if (!MathJax) {
            return;
        }
        MathJax.Hub.Config({
            showProcessingMessages: false, //关闭js加载过程信息
            messageStyle: "none", //不显示信息
            jax: ["input/TeX", "output/HTML-CSS"],
            tex2jax: {
                inlineMath: [["$", "$"], ["\\(", "\\)"]], //行内公式选择符
                displayMath: [["$$", "$$"], ["\\[", "\\]"]], //段内公式选择符
                skipTags: ["script", "noscript", "style", "textarea", "pre", "code", "a"] //避开某些标签
            },
            "HTML-CSS": {
                availableFonts: ["STIX", "TeX"], //可选字体
                showMathMenu: false //关闭右击菜单显示
            }
        });
        this.isMathjaxConfig = true; //
        console.log("----------2");
    }

    loadJS = (url) => {
        return new Promise(function(resolve, reject) {
            let script = document.createElement('script');
            script.type = "text/javascript";
            if (script.readyState){
                script.onreadystatechange = function() {
                    if (script.readyState === "loaded" ||
                        script.readyState === "complete") {
                        script.onreadystatechange = null;
                        resolve('success: '+url);
                    }
                };
            } else {
                script.onload = function(){
                    resolve('success: '+url);
                };
            }
            script.onerror = function() {
                reject(Error(url + 'load error!'));
            };
            script.src = url;
            document.body.appendChild(script);
        });
    };


    onChange = (e) => {
        const {actions,currentEvaluation,evaluation} = this.props;
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        },()=>{
            if(currentEvaluation.page === evaluation.datas.content_object_content.units.length-1){
                this._doSetAnswer('');
            }
        });
    }
    render() {
        const radioGroupStyle = {
            display: 'block'
        };
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
            paddingBottom: '10px',
            whiteSpace: 'normal',
            wordBreak: 'break-all'
        };
        const {answer,evaluation,currentEvaluation} = this.props;
        var h = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : '';
        return (
            <div className='questionItem'>
                <div className='content' dangerouslySetInnerHTML={{__html: h.passage}}/>
                <div className='options'>
                    <p  dangerouslySetInnerHTML={{__html: !h ? '' : h.questions.description}} />
                    {/*{*/}
                        {/*this.keyLight('content',h.questions.context,'yellow')*/}
                    {/*}*/}
                    <div className='options_group'>
                        <RadioGroup style={radioGroupStyle} onChange={this.onChange} value={this.state.value}>
                            {
                                h.questions.options.map((item,index)=>{
                                    return <div className="optionsDiv">
                                        <div className="options_ratio">
                                            <Radio style={radioStyle} value={item.id}></Radio>
                                        </div>
                                        <div className="options_content">
                                            <span style={{marginRight:3}}>{item.letter}.</span>
                                            <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/>
                                        </div>

                                    </div>
                                    // return <Radio style={radioStyle} value={item.id}><span style={{marginRight:10}}>{item.letter} </span>
                                    //     <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/></Radio>
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}
Science = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))(Science);

export {Science};